<!--
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2022-06-14 23:21:17
-->
<template>
    <div ref="banner" class="aside-banner" :class="bannerClass">
        <div class="aside-banner__item" v-for="(banner, index) in banners" :key="index">
            <img v-lazy="banner.logo" @click="openDetail(banner)" />
        </div>
    </div>
</template>

<script>
    import { getAdvertList } from '@/api/advert';
    export default {
        name: 'AsideBanner',
        data: () => ({
            banners: [],
            bannerClass: ''
        }),
        mounted() {
            this.getData();
            const scrollCon = document.getElementsByClassName('app-layout')[0]
            scrollCon.addEventListener('scroll', this.handelScroll)
        },
        unmounted() {
            const scrollCon = document.getElementsByClassName('app-layout')[0]
            scrollCon.removeEventListener('scroll', this.handelScroll)
        },
        methods: {
            handelScroll(e) {
                const bottom = e.target.scrollTop + this.$refs.banner.clientHeight
                const footerTop = document.getElementsByClassName('app-layout__footer')[0].offsetTop

                this.bannerClass = bottom > (footerTop - 30) ? 'bottom-class' : ((e.target.scrollTop > 1346) ? 'top-class' : '')
            },
            getData() {
                getAdvertList({
                    // isInside: 0
                }).then(({ code, data }) => {
                    if (code === 0) {
                        this.banners = data.filter(item => item.isInside === 0);
                    }
                });
            },
            openDetail(item) {
                // 平台内部链接
                if (item.isInside === 1) {
                    this.$router.push({
                        name: 'Advert',
                        query: {
                            id: item.id
                        }
                    });
                } else if (item.isInside === 0 && item.url) {
                    const aTag = document.createElement('a');
                    let href = item.url;
                    aTag.href = href;
                    aTag.target = '_blank';
                    aTag.click();
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
.aside-banner {
    &__item {
        height: 200px;
        box-shadow: 0px 2px 4px 0px rgba(153, 154, 172, 0.07);
        border-radius: 4px;
        cursor: pointer;

        img {
            width: 300px;
            height: 200px;
            border-radius: 4px;
        }

        &:not(:first-child) {
            margin-top: 20px;
        }
    }
}
.top-class {
    position: fixed;
    top:0px;
}
.bottom-class {
    position: absolute;
    bottom:0;
}

// 小屏
@include mq($small) {
    .aside-banner {
        &__item {
            height: 150px;

            img {
                width: 225px;
                height: 150px;
            }

            &:not(:first-child) {
                margin-top: 15px;
            }
        }
    }
}
</style>
